import type { PropsWithChildren } from 'react'
import type { i18n as I18n } from 'i18next'
import {
  useDashboardBootstrap,
} from './useDashboardBootstrap'
import { DashboardBootstrapContext } from './DashboardBootstrapContext'

interface DashboardBootstrapProviderProps extends PropsWithChildren {
  readonly i18n: Pick<I18n, 'changeLanguage'>
  readonly requiresLearningBootstrap: boolean
}

export function DashboardBootstrapProvider({
  children,
  i18n,
  requiresLearningBootstrap,
}: DashboardBootstrapProviderProps) {
  const bootstrapState = useDashboardBootstrap({
    i18n,
    requiresLearningBootstrap,
  })

  return (
    <DashboardBootstrapContext.Provider value={bootstrapState}>
      {children}
    </DashboardBootstrapContext.Provider>
  )
}
